<template lang="pug">
  div.fill-height
    slot(:open="open")
    ModalWrapper(
      icon="fa-fingerprint",
      :dialog="dialog",
      :header-text="$t(`form.resetTwoFactor.header`)",
      :max-width="480",
      @close="close",
    )
      template(
        v-if="dialog",
        v-slot:body="",
      )
        v-row
          p Doing so will invalidate all of user's existing device secret key, he or she will have to manually set up two factor authentication from generated QR code. 
      template(v-slot:footer="")
        v-spacer
        v-btn(
          :ripple="false",
          color="primary",
          @click='close'
        ) {{ $t("form.terms.cancel") }}

        v-btn(
          color="primary",
          :ripple="false",
          @click="submit",
        ) {{ $t(`form.terms.confirm`) }}
</template>

<script>
import { mapGetters } from 'vuex';
import ModalWrapper from '@/components/wrapper/ModalWrapper.vue';
import { clone, mergeRight, pick, pluck, without } from 'ramda';

export default {
  props: {
    submitFn: {
      type: Function,
      required: true,
    },
  },

  components: {
    ModalWrapper,
  },

  data: () => ({
    dialog: false,
  }),

  methods: {
    open(isCreate) {
      this.dialog = true;
    },

    close() {
      this.dialog = false;
    },

    submit() {
      this.submitFn().then(() => {
        this.dialog = false;
      });
    },
  },
};
</script>
